import { useConsentManager } from "@c15t/react"
import { C15tConsent } from "cookiesConsent/infrastructure/c15t/consent/consentFromC15t"

const useC15tConsent = (): C15tConsent => {
  const { consents, hasConsented } = useConsentManager()

  return {
    hasConsented: hasConsented(),
    categories: consents
  }
}

export default useC15tConsent
